import React, { useState } from "react";
import "./BookAppointment.css";
import { CgFormatBold } from "react-icons/cg";
import { FiUser, FiMail, FiPhone, FiMessageSquare } from "react-icons/fi";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BASE_URL from "../../Config";
import { LeftAnimatedDiv, RightAnimatedDiv, ZoomInDiv } from "../../componet/Animation";
import { useSelector } from "react-redux";
import SeoLinksMarquee from "../../components/SeoLinksMarquee";

function BookAppointment() {

  const [name, setName] = useState('');
  const [email, setemail] = useState('');
  const [phone, setPhone] = useState('');
  const [msg, setMsg] = useState('');
  const [method, setMethod] = useState('');
  const [loader, setLoader] = useState(false);


  const content = useSelector((state) => state.content.contactus);
  const home = useSelector((state) => state.content.home);


  // const validateForm = () => {

  //   if (!name || !email || !phone || !msg || method) {
  //     toast.error("All fields are required.");
  //     return false;
  //   }
  //   return true;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!validateForm()) return;
    setLoader(true)
    // const formData = new FormData();
    // console.log("nnirhei",images)
    // images.forEach(image => formData.append('image', image));
    try {

      const data = {
        name, email, phone, msg, method
      };

      try {
        const response = await fetch(`${BASE_URL}/users/bookAppointmentContactUs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        });
        setLoader(false)
        if (response.ok) {
          const result = await response.json();
          toast.success("We will contact yow soon");
        } else {
          toast.error(`Failed`);
        }
      } catch (error) {
        setLoader(false)
        toast.error("Somethin want wrong try again");
        console.error('Error:', error);
      }
    } catch (error) {
      setLoader(false)
      toast.error("Somethin want wrong try again");
      console.error('Error:', error);
    }
  };



  return (
    <>
      <div className="book-appointment" style={{ height: "600px" }}>
        <div className="book-appointment-container container" style={{ height: "100%" }}>
          <LeftAnimatedDiv>
            <div >
              <h1 className="contect-us-heading animate__animated animate__fadeInLeft">{content?.section1?.title}</h1>
            </div>
          </LeftAnimatedDiv>
          <ZoomInDiv className="contact-img">
            <img loading="lazy"
              title="Contact Experts"
              alt='Smiling woman holding a laptop, symbolizing easy online access to contact HairsnCares for expert advice on hair care, hair loss, and personalized solutions.' src={content?.section1?.image} style={{ height: "100%" }} />
          </ZoomInDiv>

          <RightAnimatedDiv>
            <div>
              <h4 className="sub-had-2">
                {content?.section1?.description?.split('WE ARE HERE TO HELP')[0]}
                <br />
                <span style={{ fontSize : "28px"}}>WE ARE HERE TO HELP</span>
              </h4>
            </div>
          </RightAnimatedDiv>
        </div>
        <div className='icon-abs'>
          {home?.section1?.socialImg?.map((e, ind) => {
            let alt = ind == "0" ? "Facebook" : ind == 1 ? "Whatsapp" : ind == 1 ?
              "Youtube" : ind == 3 ? "Instagram" : "X";
            let title = ind == "0" ? "Facebook logo" : ind == 1 ? "Whatsapp logo" : ind == 1 ?
              "Youtube logo" : ind == 3 ? "Instagram logo" : "X logo";
            return (
              <div onClick={() => {
                if (ind == 0) {
                  window.open("https://www.facebook.com/profile.php?id=61558302628092")
                }
                if (ind == 1) {
                  window.open("https://wa.link/pcousx")
                }
                if (ind == 2) {
                  window.open("https://www.youtube.com/@Hairsncares")
                }
                if (ind == 3) {
                  window.open("https://www.instagram.com/hairsncares/?hl=en")
                }
                if (ind == 4) {
                  window.open("https://x.com/hairsncare")
                }
              }} style={{ cursor: "pointer" }}>
                <img loading="lazy" src={e} style={{ width: "25px", height: "25px" }} alt={alt} title={title} />
              </div>
            )
          })}
        </div>
      </div>





      <div className="contact-section-two pt-70 pb-0">
        <div className="container" style={{
          paddingRight: "15px",
          paddingLeft: "15px", fontFamily: '"Poppins", sans-serif', color: "#28367a"
        }}>
          <ZoomInDiv>
            <div className=" contact-information" style={{ background: `url("/assets/img/info-bg.jpg") center top no-repeat`, backgroundSize: "cover" }}>

              <h2 style={{
                fontWeight: "600",
                lineHeight: "1.3", fontSize: "24px"
              }}>Get in touch</h2>
              <div className="touch-container">
                <div className="touch">
                  <img loading="lazy" src="/assets/img/icons/location.png" alt="Location icon indicating HairsnCares' contact information for finding expert hair care and hair loss treatment support."

                    title="Location" />
                  <div className="c-content">
                    <h4 style={{
                      fontWeight: "600",
                      lineHeight: "normal", fontSize: "16px", marginBottom: "15px"
                    }}>{content?.section2?.name}</h4>
                    <p>
                      {content?.section2?.address}
                    </p>
                  </div>
                </div>
                <div className="touch">
                  <img loading="lazy" src="/assets/img/icons/contact-icon.png"
                    alt="Phone icon representing HairsnCares contact support for expert hair care inquiries and personalized hair solutions."
                    title="Phone Support"
                  />
                  <div className="c-content">
                    <h4 style={{
                      fontWeight: "600",
                      lineHeight: "normal", fontSize: "16px", marginBottom: "15px"
                    }}>{content?.section2?.phone}</h4>
                    <p style={{
                      fontWeight: "600",
                      lineHeight: "normal", fontSize: "16px", marginBottom: "15px", wordBreak: "break-all"
                    }}>{content?.section2?.email}</p>
                  </div>
                </div>
                <div className="touch">
                  <img loading="lazy" alt='Clock icon indicating operating hours for HairsnCares hair care and hair loss treatment services.'
                    title="Operating Hours"
                    src="/assets/img/icons/time.png" />
                  <div className="c-content">
                    <h4 style={{
                      fontWeight: "600",
                      lineHeight: "normal", fontSize: "16px", marginBottom: "15px"
                    }}>{content?.section2?.time1}</h4>
                    <p style={{
                      fontWeight: "600",
                      lineHeight: "normal", fontSize: "16px", marginBottom: "15px"
                    }}>{content?.section2?.time2}</p>
                  </div>
                </div>
              </div>
            </div>
          </ZoomInDiv>
        </div>
      </div>


      <div className="contect-input container " id="section3">
        <LeftAnimatedDiv className="input-content ">

          <h2>Book an Appointment</h2>
          <div className="input-with-icon inputwith-icons">
            <FiUser className="input-icon" />
            <input placeholder="Your Name" onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="input-with-icon inputwith-icons">
            <FiMail className="input-icon" />
            <input placeholder="Your Email" onChange={(e) => setemail(e.target.value)} />
          </div>
          <div className="input-with-icon inputwith-icons">
            <FiPhone className="input-icon" />
            <input placeholder="Your Phone" onChange={(e) => setPhone(e.target.value)} />
          </div>

          <div className="textarea-with-icon inputwith-icons">
            <FiMessageSquare className="textarea-icon" />
            <textarea placeholder="Your Message" onChange={(e) => setMsg(e.target.value)} />
          </div>
          <form>
            <p>Preferred</p>
            <i className="item-i"> <label className="check-contact">
              <input type="checkbox" checked={method == "Google Meet"} onChange={() => setMethod("Google Meet")} />
              Google Meet
            </label>
              <label className="check-contact">
                <input type="checkbox" checked={method == "Zoom Meet"} onChange={() => setMethod("Zoom Meet")} />
                Zoom Meet
              </label>
              <label className="check-contact">
                <input type="checkbox" checked={method == "Whatsapp"} onChange={() => setMethod("Whatsapp")} />
                Whatsapp
              </label>
              <label className="check-contact">
                <input type="checkbox" checked={method == "Phone"} onChange={() => setMethod("Phone")} />
                Phone
              </label>
            </i>
          </form>
          <button className="input-button-content" disabled={loader} onClick={handleSubmit}>{loader ? "Please wait..." : "Book Now"}</button>
        </LeftAnimatedDiv>
        <RightAnimatedDiv>
          <h2>{content?.section3?.title}</h2>
          <figure className="text-center">
            <img loading="lazy" alt='Laptop displaying a virtual consultation with a doctor, highlighting HairsnCares easy online access to expert hair care and scalp health advice.'
              title="Virtual Consultation"
              src={content?.section3?.img} />
          </figure>
         <div  style={{paddingLeft: "80px", boxShadow: "none"}}>
           {
            content?.section3?.data?.map((item, i) => {
              return (
                <>
                  <p className="text-list">
                    <span>{"0" + (i + 1)}</span>       <h3>{item?.desc}</h3>
                  </p>
                </>
              )
            })
          }
         </div>
        </RightAnimatedDiv>
      </div>
      <SeoLinksMarquee />
      <ToastContainer position="bottom-right" />

    </>
  );
}

export default BookAppointment;
